const initialState = {
    isOpen: false,
    isInstalling: false,
}

const webAgentDialogReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SHOW_WEB_AGENT_DIALOG':
            return {
                ...state,
                isOpen: true,
                isInstalling: false,
            }

        case 'HIDE_WEB_AGENT_DIALOG':
            return {
                ...state,
                isOpen: false,
                isInstalling: false,
            }

        case 'SET_WEB_AGENT_INSTALLING':
            return {
                ...state,
                isInstalling: true,
            }

        default:
            return state
    }
}

export default webAgentDialogReducer
